import React from 'react';
import { Grid, Typography, Button } from '@mui/material';

import { ArrowForward } from '@mui/icons-material';
import { OnboardingStepProps } from 'src/pages/onboarding/OnboardingPage';

interface WelcomeStepProps extends OnboardingStepProps {
  name: string;
}

const WelcomeStep = ({ name, onNextStep }: WelcomeStepProps) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
    spacing={4}
    sx={{ height: '100%' }}
  >
    <Grid item>
      <Typography variant="h4" gutterBottom>
        Welcome {name}!
      </Typography>
    </Grid>

    <Grid item>
      <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
        We’re thrilled to have you part of our team as we work together to change the way small
        businesses communicate with their customers
      </Typography>
    </Grid>

    <Grid item sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
      <Button
        variant="contained"
        endIcon={<ArrowForward />}
        onClick={onNextStep}
        fullWidth
        size="large"
      >
        Continue
      </Button>
    </Grid>
  </Grid>
);

export default WelcomeStep;
